<template>
    <div>
        <h4 class="color-dark">{{ reviewCycle.name }}</h4>

        <l-text v-if="reviewCycle.description" :text="reviewCycle.description" />

        <hr v-show="reviewCycle.description" />

        <br />

        <l-no-data
            :text="$t(`reviews.update.labelExploreContext`)"
            icon="/img/icons/feedback.png"
        />
    </div>
</template>

<script>
import LNoData from "@/components/LNoData";
import LText from "@/components/LText";

export default {
    components: {
        LNoData,
        LText,
    },
    props: {
        reviewCycle: {
            type: Object,
            required: true,
        },
    },
};
</script>
